<template>
  <template v-if="text">
    <div ref="desRef" class="des-class" :class="[showMore ? desClass : '']">
      <div>{{ text }}</div>
    </div>

    <template v-if="showMore">
      <div v-if="showMoreButton" class="show-option" @click="handleShowMore">
        <span>{{ getText }}</span>
        <lego-icon
          class="lego-dropdown__icon"
          icon-type="df"
          icon="arrow_down"
          :size="16"
          :style="caretStyle"
        />
      </div>
    </template>
  </template>
  <span v-else class="text-no-data">{{ textNodata || $t('message.nodata') }}</span>
</template>

<script>
export default {
  name: 'cNodata',
  components: {},
  props: {
    text: {
      type: String,
      default: ''
    },
    showMore: {
      type: Boolean,
      default: false
    },
    textNodata: {
      type: String
    }
  },
  computed: {
    caretStyle() {
      let style = {};
      if (this.toggleShowMore) {
        style['transform'] = 'rotate(-180deg)';
      }
      style['transition-duration'] = '0.3s';
      return style;
    },
    getText() {
      if (this.toggleShowMore) return this.$t('label.showLess');
      return this.$t('label.showMore');
    }
  },
  mounted() {
    if (!this.showMore) return;
    this.$nextTick(() => {
      const desRef = this.$refs.desRef;
      if (!desRef) return;
      this.showMoreButton = desRef.scrollHeight > desRef.clientHeight;
    });
  },
  data() {
    return {
      showMoreButton: false,
      toggleShowMore: false,
      desClass: 'show_more'
    };
  },
  methods: {
    handleShowMore() {
      this.toggleShowMore = !this.toggleShowMore;
      this.desClass = this.toggleShowMore ? 'show_less' : 'show_more';
    }
  }
};
</script>
<style lang="scss" scoped>
.show-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 8px;

  font-size: 13px;
  line-height: 16px;
  font-weight: 500;
  color: #2c59d9;

  :deep(.lego-icon) {
    color: #2c59d9;
  }
}

.des-class {
  overflow: hidden;
  word-break: break-word;
  white-space: pre-wrap;
}
.show_more {
  max-height: 80px;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.show_less {
  max-height: max-content;
}

.text-no-data {
  color: #979daa;
}
</style>
